import { Typography } from '@mui/material'
import { Box } from '@mui/material'
// import { Link as RouterLink } from 'react-router-dom'

// const StyledRouterLink = styled(RouterLink)(({theme}) => ({
//     color: theme.palette.primary.main,
// }))


export default function Home() {
  
    return (
        <Box className="Page Home">
            <Typography variant="h3">Welcome to Mahi</Typography>
        </Box>
    )
}
